import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdjustHardSoftSkills, AdjustHardSoftSkillsSuccess, AlreadyLoaded, ClearHmVacancies, CloneVacancy, CloneVacancySuccess, DropTalentDetails, DropVacancyDetails, EndMatchCalculation, GetHmVacancies, GetMatchById, GetMatchByIdSuccess, GetStaticData, GetTalentById, GetTalentByIdSuccess, GetVacancyById, GetVacancyByIdSuccess, SetGlobalMatchCount, SetVacancyStatus, SetVacancyStatusFailure, SetVacancyStatusSuccess, StartMatchCalculation } from './dashboard.actions';
import { selectGloabalMatchCount, selectHmVacancyList, selectHmVacancyListCounts, selectHmVacancyListLoading, selectHmVacancyListPage, selectMatchCalculation, selectMatchDetails, selectStatic, selectTalentDetails, selectVacancyDetails } from './dashboard.store';
import { Actions, ofType } from '@ngrx/effects';
import { BehaviorSubject, distinctUntilChanged, filter, firstValueFrom, map, skip, take } from 'rxjs';

export enum STAT_DATA {
  EducationDegree ='EducationDegree', 
  EducationField = 'EducationField', 
  Currency = 'Currency', 
  Domain = 'Domain', 
  Language = 'Language', 
  LanguageLevel = 'LanguageLevel', 
  CompanyType = 'CompanyType', 
  CompanySize = 'CompanySize'
}

export enum VACANCY_STATUS {
  draft = 'draft', 
  published = 'published',
  deleted = 'deleted',
  hired = 'hired',
  archived = 'archived'
}

@Injectable({ providedIn: 'root' })
export class DashboardProxy {

  hmVacancyList$ = this.store.select(selectHmVacancyList);
  hmVacancyListCounts$ = this.store.select(selectHmVacancyListCounts);
  hmVacancyListPage$ = this.store.select(selectHmVacancyListPage);
  hmVacancyListLoading$ = this.store.select(selectHmVacancyListLoading);
  matchDetails$ = this.store.select(selectMatchDetails);
  vacancyDetails$ = this.store.select(selectVacancyDetails);
  talentDetails$ = this.store.select(selectTalentDetails);
  globalMatchCount$ = this.store.select(selectGloabalMatchCount);
  matchCalculation$ = this.store.select(selectMatchCalculation);
  matchCalculationVacancyId$ = new BehaviorSubject<any>(null);
  talentWasChanged$ = new BehaviorSubject<any>(false);

  constructor(private store: Store<any>, private actions$: Actions) {
    this.talentChangeWatcher();
  }

  private talentChangeWatcher() {
    const initRecalculation = localStorage.getItem('initRecalculation');
    if (initRecalculation) {
      this.recalculateMatch();
    }
    this.talentWasChanged$.pipe(distinctUntilChanged()).subscribe(val => {
      val ? localStorage.setItem('initRecalculation', 'true') : localStorage.removeItem('initRecalculation');
    });
  }

  selectStatic$(type) {
    return this.store.select(selectStatic(type));
  }

  getStaticData(dataList = null) {
    this.store.dispatch(GetStaticData({ dataList }));
  }

  getHmVacancies(searchParams, toPush, chunckSize = 20) {
    this.store.dispatch(GetHmVacancies({ searchParams, toPush, chunckSize }));
  }

  clearHmVacancies() {
    this.store.dispatch(ClearHmVacancies());
  }
  
  async setVacancyStatus(id, status, jobBoards?: string[]) {
  this.store.dispatch(SetVacancyStatus({ id, status, jobBoards }));

  return await firstValueFrom(
    this.actions$.pipe(
      ofType(SetVacancyStatusSuccess, SetVacancyStatusFailure),
      map(action => {
        if (action.type === SetVacancyStatusSuccess.type) {
          return { ok: true, data: action.payload };
        } else {
          return { ok: false, error: (action as any).error };
        }
      })
    )
  );
}

  async getMatchById(id) {
    setTimeout(() => this.store.dispatch(GetMatchById({ id })));
    return await firstValueFrom(this.actions$.pipe(ofType(GetMatchByIdSuccess, AlreadyLoaded)));
  }

  async getTalentById(id, vacancyId?: string) {
    setTimeout(() => this.store.dispatch(GetTalentById({ id, vacancyId })));
    return await firstValueFrom(this.actions$.pipe(ofType(GetTalentByIdSuccess, AlreadyLoaded)));
  }

  async getVacancyById(id) {
    setTimeout(() => this.store.dispatch(GetVacancyById({ id })));
    return await firstValueFrom(this.actions$.pipe(ofType(GetVacancyByIdSuccess, AlreadyLoaded)));
  }

  async cloneVacancy(id) {
    setTimeout(() => this.store.dispatch(CloneVacancy({ id })));
    return await firstValueFrom(this.actions$.pipe(ofType(CloneVacancySuccess)));
  }

  dropVacancyTalentDetails() {
    this.store.dispatch(DropTalentDetails());
    this.store.dispatch(DropVacancyDetails());
  }

  recalculateMatch(vacancyId = null, skipApi = false) {
  if (vacancyId) {
    this.matchCalculationVacancyId$.next(vacancyId);
  }
  this.setGlobalMatchCount(null);
  this.store.dispatch(StartMatchCalculation({ vacancyId, skipApi }));
}


  matchRecalculationFinish() {
    setTimeout(() => this.store.dispatch(EndMatchCalculation()), 1000);
  }

  setGlobalMatchCount(payload) {
    this.store.dispatch(SetGlobalMatchCount({ payload }));
  }

  async adjustHardSoftSkills(vacancyId, hardSkills, softSkills) {
    setTimeout(() => this.store.dispatch(AdjustHardSoftSkills({ vacancyId, hardSkills, softSkills })));
    return await firstValueFrom(this.actions$.pipe(ofType(AdjustHardSoftSkillsSuccess)));
  }

  startMatchCalculationAndHandleMatches(callback: () => void, vacancyId: any = null, skipApi = false) {
  this.matchCalculationVacancyId$.next(vacancyId);
  this.setGlobalMatchCount(null);
  this.store.dispatch(StartMatchCalculation({ vacancyId, skipApi }));

  this.store.select(selectMatchCalculation).pipe(
    skip(1), 
    filter(val => val === false),
    take(1)
  ).subscribe(() => {
    callback();
  });
}


}
